import { updateWasteStat } from "./azure";
import axiosInstance from "./axiosInstance";

/**
 * Trigger Metrics recompute for a camera over a date range.
 * Wraps POST /updateWasteStat (Service Bus statisticsQueue).
 *
 * @param {object} params
 * @param {string} params.cameraName - Blob folder name (e.g. camera-ak_…)
 * @param {string} params.start - YYYY-MM-DD (cycle / period start)
 * @param {string} params.stop - YYYY-MM-DD (cycle / period end)
 * @param {string} [params.imageName="metrics"] - Path param (unused by backend, kept for route compat)
 */
export async function enqueueWasteStatisticsMetrics({
  cameraName,
  start,
  stop,
  imageName = "metrics",
}) {
  if (!cameraName) {
    throw new Error("cameraName is required to enqueue Metrics");
  }
  if (!start || !stop) {
    throw new Error("start and stop dates are required to enqueue Metrics");
  }

  const body = {
    camera_name: cameraName,
    start,
    stop,
  };
  // eslint-disable-next-line no-console
  console.log("[enqueueWasteStatisticsMetrics] body", body, { imageName });

  return updateWasteStat(imageName, body);
}

/**
 * Trigger Metrics for all cameras matching Bilans filters over a period.
 * Wraps POST /updateWasteStatPeriod.
 */
export async function enqueueWasteStatisticsMetricsForPeriod({
  start,
  stop,
  keywordFilter = [],
}) {
  if (!start || !stop) {
    throw new Error("start and stop dates are required to enqueue Metrics");
  }

  const body = {
    start: String(start).split("T")[0],
    stop: String(stop).split("T")[0],
    keywordFilter,
  };
  // eslint-disable-next-line no-console
  console.log("[enqueueWasteStatisticsMetricsForPeriod] body", body);

  return axiosInstance.post("updateWasteStatPeriod", body);
}

/**
 * Build Metrics date params from a descending historyCycle (newest first)
 * as returned by historyCycleContainer, plus an optional stop ISO time.
 */
export function buildMetricsDateRangeFromHistoryCycle(
  historyCycle,
  stopTimeIso,
) {
  if (!Array.isArray(historyCycle) || historyCycle.length === 0) {
    return null;
  }

  const startIso = historyCycle[historyCycle.length - 1]?._time;
  const stopIso = stopTimeIso || historyCycle[0]?._time;
  if (!startIso || !stopIso) return null;

  return {
    start: String(startIso).split("T")[0],
    stop: String(stopIso).split("T")[0],
  };
}
